// extracted by mini-css-extract-plugin
module.exports = {"settings":"Settings-module--settings--28DsY","wrapper":"Settings-module--wrapper--3WRry","input":"Settings-module--input--O8Dwk"};